export default "__VITE_ASSET__61c140a6__"